import { baseHttp } from "./baseHttp";

const load = async (uuid: string) => {
  return baseHttp
    .get(`/api/n/surgery-request-revision-anesthesis-path/${uuid}/checkpoints`)
    .then((response: any) => response.data);
};


const ChecklistService = {
  load,
}

export default ChecklistService;
